module.exports = __webpack_public_path__ + "static/media/interior-2.bb1f4a4e.jpeg";